import { render } from "./ClientComplaintModal.vue?vue&type=template&id=4eb1fde0"
import script from "./ClientComplaintModal.vue?vue&type=script&lang=js"
export * from "./ClientComplaintModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__